// First Created - 24 May 2025
// Author - Atul Pandey
// Purpose - To provide icons for each nudge item in Sense & Guide List
// Updated - 25 May 2025 - Added Icons for Vision, Mission, Plan

import EtWabConversationIcon1SVGComp from "@/assets/img/icons/svgComp/EtWabConversationIcon1SVGComp";
import EtWabActionIcon1SVGComp from "@/assets/img/icons/svgComp/EtWabActionIcon1SVGComp";
import EtWabCreationIcon1SVGComp from "@/assets/img/icons/svgComp/EtWabCreationIcon1SVGComp";
import EtWabGratitudeIcon1SVGComp from "@/assets/img/icons/svgComp/EtWabGratitudeIcon1SVGComp";
import EtWabContributionIcon1SVGComp from "@/assets/img/icons/svgComp/EtWabContributionIcon1SVGComp";
import EtWabImpactIcon1SVGComp from "@/assets/img/icons/svgComp/EtWabImpactIcon1SVGComp";
import EtWabWinIcon1SVGComp from "@/assets/img/icons/svgComp/EtWabWinIcon1SVGComp";
import EtWabIntentionIcon1SVGComp from "@/assets/img/icons/svgComp/EtWabIntentionIcon1SVGComp";
import EtWabChallengeIcon1SVGComp from "@/assets/img/icons/svgComp/EtWabChallengeIcon1SVGComp";
import EtWabReflectionIcon1SVGComp from "@/assets/img/icons/svgComp/EtWabReflectionIcon1SVGComp" 

// 20 Feb 2026
import EtHabitsIcon1SVGComp from "@/assets/img/icons/svgComp/EtHabitsIcon1SVGComp";


import EtImprintFutureIcon1SVGComp from '@/assets/img/icons/svgComp/EtImprintFutureIcon1SVGComp'
import EtImprintVisionIcon2SVGComp from '@/assets/img/icons/svgComp/EtImprintVisionIcon2SVGComp'
import EtImprintMissionsIcon1SVGComp from '@/assets/img/icons/svgComp/EtImprintMissionsIcon1SVGComp'
import EtImprintPlansIcon1SVGComp from '@/assets/img/icons/svgComp/EtImprintPlansIcon1SVGComp'

export const nudgeIconMap = {
  "Review upcoming meetings": EtWabConversationIcon1SVGComp,
  "Clear your action backlog": EtWabActionIcon1SVGComp,
  "Reflect on yesterday’s conversations": EtWabReflectionIcon1SVGComp,
  "Capture fresh thoughts or blog ideas": EtWabCreationIcon1SVGComp,
  "Revisit prep for your next meeting": EtWabConversationIcon1SVGComp,
  "Set 2–3 priorities for today’s sessions": EtWabIntentionIcon1SVGComp,
  // "Stay energized with morning habits": EtWabContributionIcon1SVGComp, // 20 Feb 2026
  "Stay energized with morning habits": EtHabitsIcon1SVGComp, // 20 Feb 2026
  "Log conversations from earlier meetings": EtWabConversationIcon1SVGComp,
  "Add any follow-up action items": EtWabActionIcon1SVGComp,
  "Sync thoughts from team/client check-ins": EtWabConversationIcon1SVGComp,
  "Review actions completed": EtWabActionIcon1SVGComp,
  "Celebrate your wins and contributions": EtWabWinIcon1SVGComp,
  "Reflect on what energized you today": EtWabImpactIcon1SVGComp,
  "Preview meetings for tomorrow": EtWabActionIcon1SVGComp,
  "Send gratitude notes to clients or team": EtWabGratitudeIcon1SVGComp,
  // "Capture any lingering challenges or intentions": EtWabChallengeIcon1SVGComp,

  // 25 May 2025
  
  "Review your Vision & missions":EtImprintVisionIcon2SVGComp,
  "Review your Mission Performance": EtImprintMissionsIcon1SVGComp, 
};
